import * as _ from 'lodash';
import { digitalConnectionPointTypes, guidEmpty, previousStepConectionPointTypes, spotConnectionPointTypes, stringConnectionPointTypes, WideError } from '../../common';
import { AcquisitionStrategy, ActualDataType, ConnectionPoint, Dictionary, ErrorLevel, TagDefinitionVm } from '../../models';

const acquisitionValidations = [
    {
        type: AcquisitionStrategy.Spot,
        supportedTypes: spotConnectionPointTypes
    },
    {
        type: AcquisitionStrategy.PreviousStep,
        supportedTypes: previousStepConectionPointTypes
    }
];
const dataTypeValidations = [
    {
        type: ActualDataType.Digital,
        supportedTypes: digitalConnectionPointTypes
    },
    {
        type: ActualDataType.String,
        supportedTypes: stringConnectionPointTypes
    }
];

export function validateTagConnectionPoint(t: TagDefinitionVm, connectionPoints: Dictionary<ConnectionPoint>): WideError[] {
    const errors: WideError[] = [];
    if (t.acquisitionPointGuid !== guidEmpty) {
        const cp = connectionPoints[t.acquisitionPointGuid];
        if (!cp) {
            const err = new WideError(ErrorLevel.Warning, 'Connection point _guid_ not found',
                [{ guid: t.acquisitionPointGuid }]);
            errors.push(err);
        } else {
            acquisitionValidations.forEach(v => {
                if (t.acquisitionStrategy === v.type && v.supportedTypes.indexOf(cp.type) < 0) {
                    const err = new WideError(ErrorLevel.Error, 'Connection point _name_ does not support strategy _strategy_',
                        [{ name: cp.name, strategy: AcquisitionStrategy[t.acquisitionStrategy] }]);
                    errors.push(err);
                }
            });
            dataTypeValidations.forEach(v => {
                if (t.actualDataType === v.type && v.supportedTypes.indexOf(cp.type) < 0) {
                    const err = new WideError(ErrorLevel.Error, 'Connection point _name_ does not support data type _type_',
                        [{ name: cp.name, type: ActualDataType[t.actualDataType] }]);
                    errors.push(err);
                }
            });
        }
    }
    return errors;
}